import { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useModal } from './ModalProvider';
import ProfileModal from './ProfileModal';

const initials = (name) => (name || '?').trim().split(/\s+/).slice(-1)[0]?.[0]?.toUpperCase() || '?';

// Nút TÀI KHOẢN cho màn ĐỐI TÁC (DT) — giao diện tối giản không có sidebar nên không có chỗ
// Đổi thông tin / Đăng xuất. Bấm avatar -> menu nhỏ: Đổi thông tin cá nhân + Đăng xuất.
export default function PartnerAccount() {
  const { me, logout } = useAuth();
  const { openModal, closeModal } = useModal();
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onKey = (e) => e.key === 'Escape' && setOpen(false);
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);
  const ava = me.avatar ? <img className="chat-avatar-img" src={me.avatar} alt="" /> : initials(me.name);
  return (
    <div className="partner-acct">
      <button type="button" className="partner-acct-btn" onClick={() => setOpen((v) => !v)} title="Tài khoản" aria-label="Tài khoản">
        <span className="chat-avatar sm">{ava}</span>
      </button>
      {open && (
        <>
          <div className="partner-acct-back" onClick={() => setOpen(false)} />
          <div className="partner-acct-menu">
            <div className="partner-acct-head">
              <span className="chat-avatar sm">{ava}</span>
              <div className="partner-acct-who">
                <div className="partner-acct-name">{me.name}</div>
                <div className="partner-acct-role">Đối tác</div>
              </div>
            </div>
            <button type="button" className="convmenu-item" onClick={() => { setOpen(false); openModal(<ProfileModal onClose={closeModal} />); }}>
              <span className="convmenu-ic" aria-hidden="true">⚙️</span><span>Đổi thông tin cá nhân</span>
            </button>
            <button type="button" className="convmenu-item danger" onClick={logout}>
              <span className="convmenu-ic" aria-hidden="true">🚪</span><span>Đăng xuất</span>
            </button>
          </div>
        </>
      )}
    </div>
  );
}
